<template>
    <!-- <div v-if="largeModal" class="modal-window">
        <div class="modal-content"> -->
    <b-modal title="সিটিজেন" hide-footer size="lg" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="getUser" >
            <div class="container custom_modal_body">
                <div class="form-group row">
                    <label  class="col-sm-4 col-form-label">মোবাইল নাম্বার</label>
                    <div class="col-sm-8">
                        <input name="Phone" v-model="user.mobile_number" type="text" class="form-control"  placeholder="মোবাইল নাম্বার">
                        
                    </div>
                </div>
                <div class="form-group row">
                    <label  class="col-sm-4 col-form-label">জাতীয় পরিচয় নাম্বার</label>
                    <div class="col-sm-8">
                        <input name="NID"  v-model="user.nid" type="text" class="form-control"  placeholder="জাতীয় পরিচয় নাম্বার">
                        
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
                            {{message}}
                        </b-alert>
                    </div>
                </div>
            </div>
            <div class="form-group ">
                <div class="col-sm-12">
                    <input v-if="!addLoader" type="submit" value="Submit" class="btn btn-primary pull-right"/>
                    <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                    </button>
                    <button v-if="!addLoader"  @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                </div>
            </div>
        </form>
    </b-modal>
    <!-- </div>
</div> -->
</template>

<script>
    import axios from 'axios'
    export default {
        name: "find_user_for_holding",
        data(){
            return{
                largeModal:false,
                addLoader:false,
                showDismissibleAlert:false,
                message:'',
                user:{
                    nid:'',
                    mobile_number:'',
                }
            }
        },
        methods:{
            getUser() {
                if(this.user.nid || this.user.mobile_number){
                    this.addLoader = true
                    axios.post("/api/application-user/check",this.user).then(response=>{
                        this.addLoader = false
                        if(response.data.user){
                            this.largeModal = false
                            this.$emit("userInfo", response.data);
                        }
                        else{
                            this.showDismissibleAlert = true
                            this.message = 'সিটিজেন পাওয়া যায়নি, অনুগ্রহপূর্বক সিটিজেন যোগ করুন ।'
        
                        }
                    })
                }
            },
            openModal(){
                this.largeModal = true
                this.nid = '',
                this.mobile_number = ''
                this.message = ''
            },
            close(){
                this.largeModal = false
            }

        }
    }
</script>

<style scoped>

</style>